import {
	Component,
	OnInit,
	OnDestroy,
	Input,
	Output,
	EventEmitter
} from '@angular/core';
import { ContextMenuComponent } from './context-menu.component';
import { SidebarService } from '@ibe.components/common/sidebar/sidebar.service';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import * as fromStore from '../../../../app/store/index'
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { Passenger } from '@ibe/models';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import * as MiniIBEActions from '@ibe/store/actions/mini-ibe.actions';
import * as BookingStepsActions from '@ibe/store/actions/booking-steps.actions';




@Component({
	selector: 'app-context-menu',
	templateUrl: './context-menu.indra.component.html',
	styleUrls: ['./context-menu.component.css'],
	host: {
		class: 'app-context-menu'
	}
})
export class INDRAContextMenuComponent extends ContextMenuComponent
	implements OnInit, OnDestroy {

	private bookedTrip$: Observable<any> = this.store.select(fromStore.getSelectedBookedTrip);

	@Input()
	title: string;

	@Output()
	back = new EventEmitter();

	@Output()
	refresh = new EventEmitter();

	@Output()
	newSearch = new EventEmitter();

	actionsOpen = false;

	@Input()
	hideSteps = false;

	@Input()
	hiddeEdit = false;

	@Input()
	isBack: boolean = true;

	@Input()
	returnToSearch: boolean = false;
	
	isAlive = true;
	passengers: Array<Passenger>;
	contextMenuTitle;
	contextMenuStep;

	constructor(
		protected sidebarService: SidebarService,
		private store: Store<fromStore.State>,
		private router: Router,
		private route: ActivatedRoute,
		protected ibeAdminService: INDRAIbeAdminService
	) {
		super();

		this.bookedTrip$
		.pipe(takeWhile(() => this.isAlive))
		.subscribe(value => {
			if (value) {
				this.passengers = value._passengers_info;
			}
		});
	}
	ngOnDestroy(): void {
		this.isAlive = false;
		window.removeEventListener('beforeunload', this.beforeUnloadHandler.bind(this));
	}

	ngOnInit() {
		const splitTitle = this.title.split(' ');
		if (splitTitle.length > 2) {
			this.contextMenuStep = '';
			this.contextMenuTitle = splitTitle.join("");
		} else {
			this.contextMenuTitle = splitTitle[1].toLowerCase();
			this.contextMenuStep = splitTitle[0] + ' ';
		}

		window.addEventListener('beforeunload', this.beforeUnloadHandler.bind(this));
	}

	/**
	 * Emit back event to parent
	 */
	INDRA_handleBackButton() {
		if (this.returnToSearch) {
			this.newSearch.emit()
		} else {
			this.back.emit();
		}
	}

	INDRA_handleActionsButton() {
		this.sidebarService.openSidebar([
			'edit-search',
		]);
	}

	INDRA_hideSteps() {
		return this.hideSteps;
	}

	INDRA_hiddeEdit() {
		return this.hiddeEdit;
	}

	INDRA_getTranslationKey(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}

	beforeUnloadHandler(event: BeforeUnloadEvent) {
		this.refresh.emit()
	}
}
